import { render, staticRenderFns } from "./AreaCommitmentsCollapse.vue?vue&type=template&id=4789de56&scoped=true"
import script from "./AreaCommitmentsCollapse.vue?vue&type=script&lang=js"
export * from "./AreaCommitmentsCollapse.vue?vue&type=script&lang=js"
import style0 from "./AreaCommitmentsCollapse.vue?vue&type=style&index=0&id=4789de56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4789de56",
  null
  
)

export default component.exports